import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addBulkMessage,
  setChatExpanded,
  setHasInitializedMessages,
  toggleChatVisibility,
  setWelcomeSuggestions,
} from "../../state/actions";
import {
  selectHasInitializedMessages,
  selectIsChatOpen,
} from "../../Selectors/AssistantSelector";
import AiLogo from "@/assets/icons/ai-logo.svg";
import "./ChatLauncher.scss";
import { initiateSession } from "../../utils/SessionManager";
import { useScreenContext } from "../../hooks/useScreenContext";

const ChatLauncher = ({ variant = "floating" }) => {
  const dispatch = useDispatch();
  const isChatOpen = useSelector(selectIsChatOpen);
  const hasInitializedMessages = useSelector(selectHasInitializedMessages);
  const userDetail = useSelector((state) => state.userDetail);
  const { buildCurrentScreenContext } = useScreenContext();

  const handleToggleChat = async () => {
    const open = !isChatOpen;
    dispatch(toggleChatVisibility(open));
    dispatch(setChatExpanded(true));

    if (open) {
      const storedMessages = JSON.parse(localStorage.getItem("messages"));
      if (storedMessages?.length > 0) {
        dispatch(addBulkMessage(storedMessages));
        dispatch(setHasInitializedMessages(true));
      } else if (!hasInitializedMessages) {
        dispatch(setHasInitializedMessages(true));
      }

      if (!localStorage.getItem("sessionInitialized")) {
        const currentScreenContext = buildCurrentScreenContext();
        const result = await initiateSession(userDetail?.id, currentScreenContext);
        if (!result?.success) {
          console.error("[AI Assistant] Session initialization failed on chat open");
        } else if (result.suggestions) {
          dispatch(setWelcomeSuggestions(result.suggestions));
        }
      }
    }
  };

  const containerModifier =
    variant === "inline"
      ? "tooltip-container--inline"
      : variant === "sidenav"
        ? "tooltip-container--sidenav"
        : "";
  const buttonModifier =
    variant === "inline"
      ? "tooltip-message-button--inline"
      : variant === "sidenav"
        ? "tooltip-message-button--sidenav"
        : "";

  return (
    <div className={`tooltip-container ${containerModifier}`.trim()}>
      <button
        type="button"
        className={`tooltip-message-button ${buttonModifier}`.trim()}
        onClick={handleToggleChat}
        aria-label="Open AI Assistant"
      >
        <span className="tooltip-message-button__icon">
          <img src={AiLogo} alt="" aria-hidden />
        </span>
      </button>
    </div>
  );
};

export default ChatLauncher;
